import React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';
import useStyle from './style';

const Loader = props => {
  const classes = useStyle();

  return (
    <div className={classes.root} {...props}>
      <CircularProgress color="secondary" size={props.size} />
    </div>
  );
};

Loader.propTypes = {
  size: PropTypes.number,
};

Loader.defaultProps = {
  size: 40,
};

export default Loader;
